<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-page-header title="阴保状态" sub-title="Insurance status">
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="判断时间"
              prop="determineStartTime"
            >
              <a-time-picker
                v-model="form.determineStartTime"
                format="HH:mm"
                :show-second="false"
                value-format="HH:mm"
                placeholder="开始时间"
              />
              <span style="margin: 0 10px;">~</span>
              <a-time-picker
                v-model="form.determineEndTime"
                format="HH:mm"
                :show-second="false"
                value-format="HH:mm"
                placeholder="结束时间"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="判断百分比（%）"
              prop="determinePercentage"
            >
              <a-input-number
                v-model="form.determinePercentage"
                :min="0"
                :max="100"
                :precision="0"
                style='width: 100%;'
                placeholder="请输入判断百分比（%），超出判断异常"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDetermineInfo, editDetermineObj } from "@/api/saifuneng/device";
export default {
  name: 'DetermineForm',
  props: {},
  components: {

  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 日期范围
      timeRange: [],
      // 表单参数
      form: {
        deviceId: null,
        determineStartTime: null,
        determineEndTime: null,
        determinePercentage: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        determineStartTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        determineEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ],
        determinePercentage: [
          { required: true, message: '请输入百分比（%）', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {

  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        deviceId: null,
        determineStartTime: null,
        determineEndTime: null,
        determinePercentage: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd(id) {
      this.reset()
      if (id) this.form.deviceId = id
      getDetermineInfo({ deviceId: id }).then((res) => {
        this.form = res.data
      })
      this.formType = 1
      this.open = true
      this.formTitle = '数据判断'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDetermineInfo({ id: id }).then((response) => {
        this.form.deviceId = response.data.deviceId
        this.open = true
        this.formTitle = '数据判断'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          editDetermineObj({ ...this.form })
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ant-page-header {
  display: block !important;
}

.customUser_id {
  display: flex;
  align-items: center;

  .customUser_t {
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
